import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=bd7e455a&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=bd7e455a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7e455a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd7e455a')) {
      api.createRecord('bd7e455a', component.options)
    } else {
      api.reload('bd7e455a', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=bd7e455a&scoped=true&", function () {
      api.rerender('bd7e455a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YsjA50ARBAFA/JS/comp/Paginate.vue"
export default component.exports